export default "__VITE_ASSET__CYuJvtWZ__"